export const capitalizeFirstLetter = (string) => {
    const strword = string.replace('-', ' ').trim();
    const words = strword.split(" ")
    for (let i = 0; i < words.length; i++) {
      if(words[i]){
        words[i] = words[i][0].toUpperCase() + words[i].substr(1);
      }
    }
    return words.join(" ");
  }